import { render, staticRenderFns } from "./ActionBoxLink.vue?vue&type=template&id=f6332b82&"
import script from "./ActionBoxLink.vue?vue&type=script&lang=js&"
export * from "./ActionBoxLink.vue?vue&type=script&lang=js&"
import style0 from "./ActionBoxLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports